import React from 'react';
import useBusinessGuard from '../../../../hooks/useBusinessGuard';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';
import { useForm } from 'react-hook-form';

import { useDispatch, useSelector } from 'react-redux';
import {
  AddCarRentListing,
  AddMedia,
  UpdateCarRentListing,
  getcarRentListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import MapModal from '../../../common/Modal/MapModel';
import LogoCropModal from '../../../common/Modal/LogoCropModal';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';
const RentCarBusiness = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const home = useSelector((state) => state.home);
  const getlCarRentList = home?.getlCarRentList;
  const getMybusiness = home?.getMybusiness;
  const [mapModalOpen, setMapModalOpen] = useState(false);

  // The owner's business id can arrive two ways after a reload: from
  // sessionStorage (set by the Header once /business/my resolves) or directly
  // from the Redux getMybusiness object. Prefer whichever is available.
  const ownerBid =
    (getMybusiness?.businessId &&
      String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  useEffect(() => {
    // Fetch the owner's OWN business as soon as we know its id. Runs again when
    // the id becomes available post-reload (Header resolves it asynchronously),
    // which fixes the blank form after creating a business.
    if (validBid) {
      dispatch(getcarRentListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  const [ImageBlob, setImageBlob] = useState();

  const [ImageFile, setImageFile] = useState();
  // Cropper state: { src, name } of the just-picked image, shown in the modal.
  const [cropSrc, setCropSrc] = useState(null);
  const [cropName, setCropName] = useState('');
  // Additional phone numbers beyond the primary phone + whatsapp. Each entry is
  // { countryCode, mobileNumber }. Appended to mobileNumbers on submit.
  const [extraPhones, setExtraPhones] = useState([]);
  const addExtraPhone = () =>
    setExtraPhones((p) => [...p, { countryCode: '+965', mobileNumber: '' }]);
  const removeExtraPhone = (i) =>
    setExtraPhones((p) => p.filter((_, idx) => idx !== i));
  const updateExtraPhone = (i, key, value) =>
    setExtraPhones((p) =>
      p.map((row, idx) => (idx === i ? { ...row, [key]: value } : row))
    );
  const [CarRentData, setCarRentData] = useState({
    carRentName: '',
    category: '',
    mobileNumberCountryCode: '+965',
    mobileNumber: '',
    whatsAppNumberCountryCode: '+965',
    whatsAppNumber: '',
    mobileNumbers: [
      {
        countryCode: '+965',
        mobileNumber: '',
      },
    ],
    about: '',
    location: '',
    gps: {
      lat: '29.378586',
      long: '47.990341',
    },
    website: '',
    socialMedia: {
      FACEBOOK: '',
      SNAPCHAT: '',
      INSTAGRAM: '',
      YOUTUBE: '',
      LINKEDIN: '',
      TWITTER: '',
    },
    mediaIds: {
      LOGO: [],
    },
  });

  const dispatch = useDispatch();

  // One business per account: redirect if the user already owns a
  // different business instead of failing this add-form on save.
  useBusinessGuard('CAR04');

  // [CF] Clear ALL the form fields — including the phone, WhatsApp and any
  // additional phone numbers (these are state-controlled, so reset() alone
  // didn't clear them).
  const ResetHendler = () => {
    reset();
    setExtraPhones([]);
    setCarRentData((user) => ({
      ...user,
      carRentName: '',
      mobileNumberCountryCode: '+965',
      mobileNumber: '',
      whatsAppNumberCountryCode: '+965',
      whatsAppNumber: '',
      mobileNumbers: [{ countryCode: '+965', mobileNumber: '' }],
      website: '',
      about: '',
      socialMedia: {
        FACEBOOK: '',
        SNAPCHAT: '',
        INSTAGRAM: '',
        YOUTUBE: '',
        LINKEDIN: '',
        TWITTER: '',
      },
    }));
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setCarRentData((user) => ({ ...user, [name]: value }));
  }

  // Bridge react-hook-form registration with the controlled state updater so
  // validation runs live (as the user types) AND the controlled value stays in
  // sync — fixes the previous conflict where handleChange overrode RHF's onChange.
  const field = (fieldName, rules) => {
    const r = register(fieldName, rules);
    return {
      ...r,
      onChange: (e) => {
        r.onChange(e);
        handleChange(e);
      },
    };
  };
  const mediaChange = (e) => {
    setCarRentData({
      ...CarRentData,
      socialMedia: {
        ...CarRentData.socialMedia,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate: must be an image, and within a sane size limit
    if (!file.type || !file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Invalid file',
        text: 'Please upload an image file (JPG, PNG, etc.).',
        icon: 'error',
      });
      event.target.value = '';
      return;
    }
    const MAX_MB = 12;
    if (file.size > MAX_MB * 1024 * 1024) {
      Swal.fire({
        title: 'Image too large',
        text: `Please upload an image smaller than ${MAX_MB} MB.`,
        icon: 'error',
      });
      event.target.value = '';
      return;
    }

    // Load the picked image and open the cropper modal. The owner frames the
    // logo in a square; the cropped, compressed JPEG is uploaded on Apply.
    const reader = new FileReader();
    reader.onload = (ev) => {
      setCropName(file.name || 'logo');
      setCropSrc(ev.target.result);
    };
    reader.readAsDataURL(file);
    // Allow re-picking the same file later.
    event.target.value = '';
  };

  // Upload a cropped square logo (called by the cropper modal's Apply button).
  const uploadCroppedLogo = (result) => {
    setCropSrc(null);
    if (!result || !result.file) return;
    setImageFile(result.file);
    // The preview <img> reads ImageBlob?.blob, so wrap the data URL in { blob }
    // (same shape the prefill uses) — otherwise the cropped image won't show.
    if (result.preview) setImageBlob({ blob: result.preview });
    const formData = new FormData();
    formData.append('media', result.file);
    // silent: the inline preview is the confirmation, so no success popup.
    pendingLogoUploadRef.current = true;
    dispatch(AddMedia({ formData, silent: true }));
  };

  const pendingLogoUploadRef = useRef(false);
  /* [CF 2026-08-11] The uploaded logo id arrives asynchronously in the
     `[counter]` effect below, but TWO other effects (the prefill and the
     mobileNumbers rebuild) also call setState with their own stale snapshot of
     this object — either can drop the fresh LOGO id before the form is
     submitted, and the save then re-sends the OLD id, which the owner sees as
     "the logo did not change". The ref is written the instant the upload
     resolves and is applied again at submit time, so it cannot be clobbered. */
  const logoIdRef = useRef(null);
  const counter = useSelector((state) => state.home.AddMediaList);

  /* [CF 2026-08-09 #18] `home.AddMediaList` is a GLOBAL redux slot written by
     every media upload anywhere in the app, and nothing ever clears it. This
     effect therefore also fired on MOUNT, off whatever the last upload had
     left behind, silently stamping the PREVIOUS company's logo id into this
     form — save it and that company's logo came back, which is the "updating
     one company's logo reverts the other one" report. Consume the slot only
     when THIS page actually started an upload; same guard the `*Banner.js`
     screens already carry as `pendingUploadRef`. */
  useEffect(() => {
    if (!pendingLogoUploadRef.current) return;
    pendingLogoUploadRef.current = false;
    console.log('hellow ', counter);
    if (counter !== undefined) {
      const logoid = counter?.data?.response?.media[0]?.mediaId;
      logoIdRef.current = logoid;
      console.log('logoid', logoid);
      // const logoid = ['ksjdkfjaslkd'];
      setCarRentData({
        ...CarRentData,
        mediaIds: {
          ...CarRentData.mediaIds,
          LOGO: [logoid],
        },
      });
    }
  }, [counter]);

  useEffect(() => {
    setCarRentData({
      ...CarRentData,
      mobileNumbers: [
        {
          countryCode: CarRentData.mobileNumberCountryCode,
          mobileNumber: CarRentData.mobileNumber,
        },
        {
          countryCode: CarRentData.whatsAppNumberCountryCode,
          mobileNumber: CarRentData.whatsAppNumber,
        },
      ],
    });
  }, [
    CarRentData.mobileNumberCountryCode,
    CarRentData.mobileNumber,
    CarRentData.whatsAppNumberCountryCode,
    CarRentData.whatsAppNumber,
  ]);

  useEffect(() => {
    // Only pre-fill from the owner's OWN business, identified by BusinessId —
    // never from the shared customer listing (which holds every vendor and
    // would otherwise show the first vendor's data here). Compare as strings so
    // a numeric carRentId still matches the sessionStorage/Redux id.
    if (
      getlCarRentList?.length &&
      validBid &&
      String(getlCarRentList[0]?.carRentId) === String(ownerBid)
    ) {
      const gps =
        typeof getlCarRentList[0]?.gps === 'string'
          ? JSON.parse(getlCarRentList[0]?.gps)
          : getlCarRentList[0]?.gps;
      const socialMedia =
        typeof getlCarRentList[0]?.socialMedia === 'string'
          ? JSON.parse(getlCarRentList[0]?.socialMedia)
          : getlCarRentList[0]?.socialMedia;
      console.log('socialMedia', socialMedia);

      const logo = getlCarRentList[0]?.businessMedia?.find(
        (media) => media.mediaType === 'LOGO'
      )?.media;
      setCarRentData({
        carRentName: getlCarRentList?.[0]?.carRentName,
        category: getlCarRentList?.[0]?.category,
        mobileNumberCountryCode: getlCarRentList?.[0]?.mobileNumberCountryCode,
        mobileNumber: getlCarRentList?.[0]?.mobileNumber,
        whatsAppNumberCountryCode:
          getlCarRentList?.[0]?.whatsAppNumberCountryCode,
        whatsAppNumber: getlCarRentList?.[0]?.whatsAppNumber,
        mobileNumbers: [
          {
            countryCode: '',
            mobileNumber: '',
          },
        ],
        about: getlCarRentList?.[0]?.about,
        location: getlCarRentList?.[0]?.location,
        gps: {
          lat: gps?.lat,
          long: gps?.long,
        },
        website: getlCarRentList?.[0]?.website,
        socialMedia: {
          FACEBOOK: socialMedia?.FACEBOOK,
          SNAPCHAT: socialMedia?.SNAPCHAT,
          INSTAGRAM: socialMedia?.INSTAGRAM,
          YOUTUBE: socialMedia?.YOUTUBE,
          LINKEDIN: socialMedia?.LINKEDIN,
          TWITTER: socialMedia?.TWITTER,
        },
        mediaIds: {
          LOGO: [logo?.mediaId],
        },
      });
      setImageBlob({ blob: logo?.path });

      // Load any saved numbers beyond the first two (phone + whatsapp) into the
      // additional-phones editor so they show up and can be edited.
      const _savedNums = getlCarRentList?.[0]?.mobileNumbers;
      if (Array.isArray(_savedNums) && _savedNums.length > 2) {
        setExtraPhones(
          _savedNums.slice(2).map((n) => ({
            countryCode: n?.countryCode || '+965',
            mobileNumber: n?.mobileNumber || '',
          }))
        );
      }

      // Sync the prefilled values into react-hook-form too. The inputs are
      // controlled by state, but RHF only tracks values entered through its own
      // onChange — without this, a prefilled form would fail validation on
      // submit ("Business name / Phone number is required") even though the
      // fields are visibly filled (e.g. when the owner edits only the logo).
      setValue('carRentName', getlCarRentList?.[0]?.carRentName || '', {
        shouldValidate: true,
      });
      setValue('mobileNumber', getlCarRentList?.[0]?.mobileNumber || '', {
        shouldValidate: true,
      });
      setValue('whatsAppNumber', getlCarRentList?.[0]?.whatsAppNumber || '', {
        shouldValidate: true,
      });
    }
  }, [getlCarRentList]);
  console.log('getlCarRentListbusiness', getlCarRentList);

  const datasubmit = () => {
    // Append filled-in additional phone numbers to the primary phone + whatsapp
    // entries already built in CarRentData.mobileNumbers.
    const _extra = extraPhones.filter(
      (p) => p.mobileNumber && String(p.mobileNumber).trim()
    );
    const _payload = sanitizeWhatsAppFields({
      ...CarRentData,
      mobileNumbers: [...(CarRentData.mobileNumbers || []), ..._extra],
    });
    if (logoIdRef.current) {
      _payload.mediaIds = {
        ..._payload.mediaIds,
        LOGO: [logoIdRef.current],
      };
    }
    // For a brand-new owner getlCarRentList is undefined — guard with optional
    // chaining so we don't throw before dispatching (which made Update do
    // nothing). Existing business -> update, otherwise create.
    if (getlCarRentList?.length > 0) {
      dispatch(UpdateCarRentListing(_payload));
    } else {
      dispatch(AddCarRentListing(_payload));
    }
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-rent-car-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-rent-car-cars',
      label: t('Manage Cars'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-rent-car-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-rent-car-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  // Close map modal
  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  // Handle location selection from map
  const handleLocationSelect = (location) => {
    console.log(location);

    setCarRentData({
      ...CarRentData,
      location: location.address,
      gps: {
        lat: location.lat,
        long: location.long,
      },
    });
  };

  return (
    <div>
      <div class="main-content-area" style={{ paddingTop: '24px' }}>
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2>{t('Manage Business')}</h2>

              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="form-group">
                  <label for="g-mb-business-name">{t('Business Name')}</label>
                  <input
                    {...field('carRentName', {
                      required: 'Business name is required',
                      minLength: {
                        value: 4,
                        message: 'Business name must be at least 4 characters',
                      },
                    })}
                    name="carRentName"
                    value={CarRentData.carRentName}
                    type="text"
                    className={classNames('form-control', {
                      'is-invalid': errors.carRentName,
                    })}
                    id="g-mb-business-name"
                    placeholder={t("Business Name")}
                  />
                  {errors.carRentName && (
                    <p className="invalid-feedback">
                      {errors.carRentName.message}
                    </p>
                  )}
                </div>

                <div class="form-group">
                  <label>{t('Business Logo Image')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                            objectFit: 'cover',
                            border: '1px solid #e3e3e3',
                            background: '#f7f7f7',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src={CarRentData.sImage ?}
                          src={
                            ImageBlob?.blob
                              ? ImageBlob?.blob
                              : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="files"
                        >
                          {t('Upload Logo image')}
                        </label>
                        <input
                          type="file"
                          id="files"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class='form-group'>
									<label>Business Logo Image</label>
									<div class='row align-items-center'>
										<div class='col-auto'>
											<div class='circle'>
												<img
													class='profile-pic img-fluid'
													src='assets/images/camera.jpg'
													alt=''
												/>
											</div>
										</div>
										<div class='col-auto'>
											<div class='p-image'>
												<Link
													class='btn btn-outline-secondary upload-button btn-sm'
													href='javascript:void(0);'
													role='button'>
													Upload Logo image
												</Link>
												<input
													class='file-upload'
													type='file'
													accept='image/*'
												/>
											</div>
										</div>
									</div>
								</div> */}

                <div class="form-group">
                  <label for="g-mb-phone-number">{t('Phone Number')}</label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="mobileNumberCountryCode"
                        value={CarRentData.mobileNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...field('mobileNumber', {
                          required: t('Phone number is required'),
                          pattern: {
                            value: /^\d{8}$/,
                            message: t(
                              'Please enter a valid 8-digit phone number'
                            ),
                          },
                        })}
                        name="mobileNumber"
                        value={CarRentData.mobileNumber}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.mobileNumber,
                        })}
                        id="g-mb-phone-number"
                        placeholder={t("Phone Number")}
                      />
                      {errors.mobileNumber && (
                        <p className="invalid-feedback">
                          {errors.mobileNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-whatsApp-number">
                    {t('WhatsApp Number')} <small>(Optional)</small>
                  </label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="whatsAppNumberCountryCode"
                        value={CarRentData.whatsAppNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...field('whatsAppNumber', {
                          pattern: {
                            value: /^\d{8}$/,
                            message: t(
                              'Please enter a valid 8-digit whatsapp number'
                            ),
                          },
                        })}
                        name="whatsAppNumber"
                        value={CarRentData.whatsAppNumber}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.whatsAppNumber,
                        })}
                        id="g-mb-whatsApp-number"
                        placeholder={t("WhatsApp Number")}
                      />
                      {errors.whatsAppNumber && (
                        <p className="invalid-feedback">
                          {errors.whatsAppNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {t('Additional Phone Numbers')}{' '}
                    <small>({t('Optional')})</small>
                  </label>
                  {extraPhones.map((phone, idx) => (
                    <div class="row" key={idx} style={{ marginBottom: '8px' }}>
                      <div class="col-4">
                        <select
                          class="form-control"
                          value={phone.countryCode}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'countryCode', e.target.value)
                          }
                        >
                          <option value="+965">+965</option>
                        </select>
                      </div>
                      <div class="col-7">
                        <input
                          type="tel"
                          inputMode="numeric"
                          class="form-control"
                          value={phone.mobileNumber}
                          placeholder={t('Phone Number')}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'mobileNumber', e.target.value)
                          }
                        />
                      </div>
                      <div class="col-1 px-0">
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-block"
                          title={t('Remove')}
                          onClick={() => removeExtraPhone(idx)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    onClick={addExtraPhone}
                  >
                    + {t('Add phone number')}
                  </button>
                </div>

                {/* <div class="form-group">
                  <label for="g-mb-business-category">
                    {t('Business Category')}
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    id="g-mb-business-category"
                    name="category"
                    value={CarRentData.category}
                    placeholder={t("Define Category here")}
                    onChange={handleChange}
                  />
                </div> */}

                <div class="form-group">
                  <label for="g-mb-about-company">
                    {t('About the Company')} <small>({t('Optional')})</small>
                  </label>
                  <textarea
                    name="about"
                    value={CarRentData.about}
                    onChange={handleChange}
                    class="form-control"
                    id="g-mb-about-company"
                    rows="2"
                  ></textarea>
                </div>

                <div className="form-group">
                  <label htmlFor="g-mb-location-map">
                    {t('Select Location on Map')}
                  </label>
                  <div className="input-group">
                    <input
                      name="location"
                      value={CarRentData?.location}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      id="g-mb-location-map"
                      readOnly
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/map-marker.svg"
                          alt="Map"
                          style={{ height: '20px', width: '20px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <small className="form-text text-muted">
                    {t(
                      'Click to open the map and select your business location'
                    )}
                  </small>
                </div>
                <MapModal
                  open={mapModalOpen}
                  handleClose={handleCloseMap}
                  onLocationSelect={handleLocationSelect}
                  currentLocation={{
                    lat: CarRentData.gps?.lat,
                    long: CarRentData.gps?.long,
                    address: CarRentData?.location,
                  }}
                />

                <LogoCropModal
                  open={!!cropSrc}
                  imageSrc={cropSrc}
                  fileName={cropName}
                  onCancel={() => setCropSrc(null)}
                  onApply={uploadCroppedLogo}
                />

                <div class="form-group">
                  <label for="g-mb-website">
                    {t('Website')} <small>({t('Optional')})</small>
                  </label>
                  <input
                    name="website"
                    value={CarRentData.website}
                    onChange={handleChange}
                    type="text"
                    class="form-control"
                    id="g-mb-website"
                    placeholder={t("Website")}
                  />
                </div>

                <div class="form-group">
                  <h5>{t('Add Social Media Channels')}</h5>
                  <ul
                    class="list-inline mb-0 social-media-channel "
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <li
                      class="list-inline-item mb-2 "
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/facebook.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="FACEBOOK"
                        value={CarRentData?.socialMedia?.FACEBOOK}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('facebook')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/instagram.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="INSTAGRAM"
                        value={CarRentData?.socialMedia?.INSTAGRAM}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('instagram')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/twitter.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="TWITTER"
                        value={CarRentData?.socialMedia?.TWITTER}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('twitter')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/youtube.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="YOUTUBE"
                        value={CarRentData?.socialMedia?.YOUTUBE}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('youtube')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/linkedin.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="LINKEDIN"
                        value={CarRentData?.socialMedia?.LINKEDIN}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('linkedin')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/snapchat.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="SNAPCHAT"
                        value={CarRentData?.socialMedia?.SNAPCHAT}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('snapchat')}
                      />
                    </li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn btn-secondary btn-block"
                      onClick={ResetHendler}
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-warning btn-block"
                      // role='button'
                    >
                      {t('Update')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentCarBusiness;
